module.exports = __webpack_public_path__ + "img/scanner-barcode.460899fc.svg";